<template>
  <div class="shop">
    <div class="top" style="margin-bottom:10px">
      <!-- <el-button size="small" type="primary" @click="exportWoods"
        >导出数据</el-button
      > -->

      <el-button
        style="float:right;margin-bottom:20px;"
        class="search"
        size="small"
        type="primary"
        @click="searchList"
        >搜索</el-button
      >
      <el-input
        style="float:right;margin-right: 10px;"
        class="search input"
        size="small"
        v-model="receive_mobile"
        placeholder="收卡人手机号"
        clearable
      ></el-input>
      <el-input
        style="float:right;margin-right: 10px;"
        class="search input"
        size="small"
        v-model="mobile"
        placeholder="转卡人手机号"
        clearable
      ></el-input>
      <el-input
        style="float:right;margin-right: 10px;"
        class="search input"
        size="small"
        v-model="card_sn"
        placeholder="卡号"
        clearable
      ></el-input>
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="id"></el-table-column>
      <el-table-column label="转卡时间" prop="created_at"></el-table-column>
      <el-table-column label="卡号" prop="card_sn"></el-table-column>
      <el-table-column label="面值" prop="card_amount"></el-table-column>
      <el-table-column label="转卡人" prop="user_mobile"></el-table-column>
      <el-table-column label="收卡人" prop="receive_mobile"></el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import { getMoveRecord } from '@/api/redpacketManage'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      card_sn: '', // 卡号
      receive_mobile: '', // 接受人手机号
      mobile: '', // 转卡人手机号
      tableData: [],
      labelPosition: 'right',
      is_export: 0, //0非导出，1导出
      form: {
        page: 1,
        size: 10
      },
      total: 0
    }
  },
  mounted() {
    this.getMoveRecord()
  },
  methods: {
    //获取列表数据
    async getMoveRecord() {
      let is_export = this.is_export
      let card_sn = this.card_sn
      let receive_mobile = this.receive_mobile
      let mobile = this.mobile
      let url = `page=${this.form.page}&is_export=${is_export}&mobile=${mobile}&card_sn=${card_sn}&receive_mobile=${receive_mobile}`
      let res = await getMoveRecord(url)
      console.log(res)
      if (res.code === 10000) {
        if (this.is_export == 1) {
          this.is_export = 0
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          )
          return
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.$message.error(res.message)
      }
    },
    //导出
    exportWoods() {
      this.is_export = 1
      this.getMoveRecord()
    },
    //搜索
    searchList() {
      this.is_export = 0
      this.form.page = 1
      this.getMoveRecord()
    },
    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getMoveRecord()
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top .input {
    width: 150px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
